import { render } from "./Redimensionar.vue?vue&type=template&id=10d0d8e5"
const script = {}
script.render = render

export default script